// extracted by mini-css-extract-plugin
export default {"container":"BottomPart_container__FdhEn","background":"BottomPart_background__5MWx8","BottomPart":"BottomPart_BottomPart__pc6Tx"};